<template>
  <div>
    <v-dialog v-model="showDialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Update Alert Status</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field label="Message" v-model="message" :color="'primaryText'" outline></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="showDialog = false">Close</v-btn>
          <v-btn
            color="blue darken-1"
            flat
            @click="update(); showDialog = false;"
          >Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { EventBus } from '@/services/event-bus'
const momentTz = require('moment-timezone')

export default {
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    status: {
      type: String,
      required: true
    },
    ref_id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      message: ''
    }
  },
  computed: {
    ...mapGetters(['getSelectedPlantId', 'getUserData', 'getActivePlantInfo']),
    showDialog: {
      get() {
        return this.dialog
      },
      set(value) {
        this.$emit('toggle', value)
      }
    }
  },
  methods: {
    ...mapActions('alert', ['updateAlert']),
    update() {
      const { email } = this.getUserData
      const payload = {
        plant_id: this.getSelectedPlantId,
        status: this.status,
        message: this.message,
        ref_id: this.ref_id,
        sensor_time: momentTz().tz(this.getActivePlantInfo('timezone')).format('X'),
        user: email
      }

      this.updateAlert(payload).then((result) => {
        if (result.status === 200) {
          EventBus.$emit('alert:update', {
            message: 'Alert updated successfully',
            status: 'success' })
          
          this.$emit('alert:action-update', {
            action: this.status,
            message: this.message,
            _id: this.ref_id,
            time: momentTz().tz(this.getActivePlantInfo('timezone')).format('X'),
            user: email
          })
        } else {
          EventBus.$emit('alert:update', {
            message: 'Alert update failed!',
            status: 'error'
          })
        }
      }).catch((err) => {
        EventBus.$emit('alert:update', {
          message: 'Alert update failed!',
          status: 'error'
        })
        console.log(err)
      })
    }
  }
}
</script>